import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Theme } from '@mui/material/styles/createTheme';
import Grid from '@mui/material/Grid';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import Link from '@mui/material/Link';
import { APP_ROOT } from 'src/route_constants';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      alignItems: 'center',
    },
    value: {
      flexGrow: 1,
      fontSize: '14px',
      fontWeight: 600,
      [theme.breakpoints.down('sm')]: {
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden'
      },
    },
    valueContainer: {
      flexBasis: 'auto',
      maxWidth: '100%'
    }
  })
);

interface Props {
  username: string;
}

const SummaryLink: React.FC<Props> = (props: Props) => {
  const { username } = props;
  const classes = useStyles();

  return (
    <Box>
      <Box className={classes.container}>
        <Grid container w-100>
          <Grid item xs={9} className={classes.valueContainer} display="flex" alignItems="center">
            <Link target="_blank" href={`/apply/${username}`}>
              <Typography className={classes.value}>
                {APP_ROOT}/apply/{username}
              </Typography>
            </Link>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default SummaryLink;
